import { createContext, useContext, type ReactNode } from 'react';
import { useCurrentCharacterModelId } from '@sorrem-client/ui/hooks';

/** The body (`characterModelId`) item icons show for by default; undefined outside an `ItemIconBodyProvider`. */
const ItemIconBodyContext = createContext<string | undefined>(undefined);

/**
 * Gives every `ItemIcon` below the selected character's body, so items that
 * look different on each body (outfit armor) show that body's icon without
 * each caller passing it. Kept in context, not read by `ItemIcon` itself, so
 * an icon renders without the app store (tests, stand-alone pages).
 */
export function ItemIconBodyProvider({ children }: { readonly children: ReactNode }): JSX.Element {
    const characterModelId = useCurrentCharacterModelId();
    return <ItemIconBodyContext.Provider value={characterModelId}>{children}</ItemIconBodyContext.Provider>;
}

/** The default body for item icons (see `ItemIconBodyProvider`). */
export function useItemIconBody(): string | undefined {
    return useContext(ItemIconBodyContext);
}
